export const AVATAR_URL =
  'https://customer-assets.emergentagent.com/job_site-clone-platform/artifacts/nm10cdo1_ai-agent.png';
export const CAL_LINK = 'https://cal.com/terrywebster/30min';
export const BOOK_REPLY = 'Book a Discovery Call';
